import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Anlagen API
export const anlagenAPI = {
  getAll: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.kunde_id) params.append('kunde_id', filters.kunde_id);
    if (filters.lec_nummer) params.append('lec_nummer', filters.lec_nummer);
    if (filters.search) params.append('search', filters.search);
    
    const queryString = params.toString();
    const url = queryString ? `${API}/anlagen?${queryString}` : `${API}/anlagen`;
    
    const response = await axios.get(url, { headers: getAuthHeaders() });
    return response.data;
  },

  getById: async (id) => {
    const response = await axios.get(`${API}/anlagen/${id}`, { headers: getAuthHeaders() });
    return response.data;
  },

  getByQR: async (qrCode) => {
    const response = await axios.get(`${API}/anlagen/qr/${qrCode}`, { headers: getAuthHeaders() });
    return response.data;
  },

  create: async (data) => {
    const response = await axios.post(`${API}/anlagen`, data, { headers: getAuthHeaders() });
    return response.data;
  },

  update: async (id, data) => {
    const response = await axios.put(`${API}/anlagen/${id}`, data, { headers: getAuthHeaders() });
    return response.data;
  },

  delete: async (id) => {
    const response = await axios.delete(`${API}/anlagen/${id}`, { headers: getAuthHeaders() });
    return response.data;
  },

  addFoto: async (id, file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await axios.post(`${API}/anlagen/${id}/add-foto`, formData, {
      headers: { ...getAuthHeaders(), 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  }
};

// Wartungen API
export const wartungenAPI = {
  getByAnlage: async (anlageId) => {
    const response = await axios.get(`${API}/wartungen/anlage/${anlageId}`, { headers: getAuthHeaders() });
    return response.data;
  },

  getById: async (id) => {
    const response = await axios.get(`${API}/wartungen/${id}`, { headers: getAuthHeaders() });
    return response.data;
  },

  create: async (data) => {
    const response = await axios.post(`${API}/wartungen`, data, { headers: getAuthHeaders() });
    return response.data;
  },

  addFoto: async (id, file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await axios.post(`${API}/wartungen/${id}/add-foto`, formData, {
      headers: { ...getAuthHeaders(), 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  exportPDF: async (id) => {
    const response = await axios.get(`${API}/export/wartung/${id}/pdf`, {
      headers: getAuthHeaders(),
      responseType: 'blob'
    });
    return response.data;
  }
};

// QR Code API
export const qrCodeAPI = {
  generate: (qrCode) => {
    return `${API}/qrcode/${qrCode}`;
  }
};

// Kunden API
export const kundenAPI = {
  getAll: async () => {
    const response = await axios.get(`${API}/kunden`, { headers: getAuthHeaders() });
    return response.data;
  },

  getById: async (id) => {
    const response = await axios.get(`${API}/kunden/${id}`, { headers: getAuthHeaders() });
    return response.data;
  },

  create: async (data) => {
    const response = await axios.post(`${API}/kunden`, data, { headers: getAuthHeaders() });
    return response.data;
  },

  update: async (id, data) => {
    const response = await axios.put(`${API}/kunden/${id}`, data, { headers: getAuthHeaders() });
    return response.data;
  },

  delete: async (id) => {
    const response = await axios.delete(`${API}/kunden/${id}`, { headers: getAuthHeaders() });
    return response.data;
  },

  getAnlagen: async (id) => {
    const response = await axios.get(`${API}/kunden/${id}/anlagen`, { headers: getAuthHeaders() });
    return response.data;
  }
};

// Vorlagen API
export const vorlagenAPI = {
  getAll: async () => {
    const response = await axios.get(`${API}/vorlagen`, { headers: getAuthHeaders() });
    return response.data;
  },

  getById: async (id) => {
    const response = await axios.get(`${API}/vorlagen/${id}`, { headers: getAuthHeaders() });
    return response.data;
  },

  update: async (id, data) => {
    const response = await axios.put(`${API}/vorlagen/${id}`, data, { headers: getAuthHeaders() });
    return response.data;
  },

  kopieren: async (id, data) => {
    const response = await axios.post(`${API}/vorlagen/${id}/kopieren`, data, { headers: getAuthHeaders() });
    return response.data;
  }
};

// Import API
export const importAPI = {
  preview: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await axios.post(`${API}/import/preview`, formData, {
      headers: { ...getAuthHeaders(), 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  importKunden: async (file, updateExisting = false) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('update_existing', updateExisting);
    const response = await axios.post(`${API}/import/kunden`, formData, {
      headers: { ...getAuthHeaders(), 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  importAnlagen: async (file, updateExisting = false) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('update_existing', updateExisting);
    const response = await axios.post(`${API}/import/anlagen`, formData, {
      headers: { ...getAuthHeaders(), 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  }
};